export const COUNTRIES = [
    { code: "au", label: "Australia" },
    { code: "us", label: "United States" },
    { code: "uk", label: "United Kingdom" },
    { code: "ca", label: "Canada" },
    { code: "nz", label: "New Zealand" },
    { code: "in", label: "India" },
    { code: "ie", label: "Ireland" },
    { code: "sg", label: "Singapore" },
    { code: "ae", label: "United Arab Emirates" },
    { code: "de", label: "Germany" },
    { code: "fr", label: "France" },
];
